<template>
	<p></p>
</template>

<script>

export default {
	name: 'IWEmpty',
	props: {
		
	}
}
</script>

<style scoped>
</style>
